import React from "react";
import PropTypes from "prop-types";
import { OrderedMap } from "immutable";
import { Row, Col, Table, Button } from "antd"; 


// export function RenderParameterThreshold({ record }) {
//     if(record.stages === "one_of") {
//         return record.parameter_threshold.join(",");
//     }
//     return record.parameter_threshold;
// }

function RenderProfileActions() {
    return (
        <React.Fragment>
            <Button type={"link"} icon={"edit"}> Edit </Button>
            <Button type={"link"} icon={"tool"}> Password </Button>
            <Button type={"link"} icon={"user-delete"}> Revoke </Button>
        </React.Fragment>
    );
}

const TABLE_COLUMNS = new OrderedMap({
    name: {
        key: "name",
        title: "Name",
        dataIndex: "name",
        width: 100,
    },
    email: {
        key: "email",
        title: "Email",
        dataIndex: "email",
        width: 200
    },
    role: {
        key: "role",
        title: "Role",
        dataIndex: "role",
        width: 100,
        render: _ => _.label,
    },
    status: {
        key: "status",
        title: "Status",
        dataIndex: "status",
        width: 100
    },
    actions: {
        key: "actions",
        title: "Actions",
        dataIndex: "actions",
        width: 200,
        render: () => RenderProfileActions()
    }
});


const SAMPLE_DATASOURCE = [{
    id: 1,
    name: "Robin P R",
    email: "robin.pr@muthootgroup.com",
    role: { label: "Manager", value: "one_of" },
    status: "Active",
    parameter_applicability: "Mandatory",
    deviation_support_options: ["Only one of the options is added"]
}];


class UsersPermissions extends React.Component {

    state = {
        editing: false
    }


    toggleEditMode = mode => {
        this.setState({
            editing: mode
        });
    }

    getTitle = () => {
        // if (this.state.editing) {
        //     return(
        //         <Row>
        //             <Col span={24} >
        //                 <Row type={"flex"} justify={"end"}>
        //                     <Col style={{ padding: "0px 5px"}}>
        //                         <Button icon={"edit"} type={"default"} >
        //                             Request Policy Parameter
        //                         </Button>
        //                     </Col>
        //                     <Col style={{ padding: "0px 5px"}}>
        //                         <Button icon={"caret-right"} type={"primary"} onClick={this.toggleEditMode.bind(null, false)}>
        //                             Save
        //                         </Button>
        //                     </Col>
        //                 </Row>
        //             </Col>
        //         </Row>
        //     );
        // }
        return(
            <Row>
                <Col span={24} >
                    <Row type={"flex"} justify={"end"}>
                        <Col style={{ padding: "0px 5px"}}>
                            <Button icon={"user-add"} type={"primary"}>
                                Add User
                            </Button>
                        </Col>
                    </Row>
                </Col>
            </Row>
        );
    }



    render() {
        return(
            <Row>
                <Col>
                    <Table
                        title={this.getTitle}
                        size={"small"}
                        // bordered={true}
                        columns={TABLE_COLUMNS.toList()}
                        dataSource={SAMPLE_DATASOURCE}
                        rowKey={"id"}
                        loading={false}
                        pagination={false}
                    />
                </Col>
            </Row>
        );
    }
}

UsersPermissions.propTypes = {
    id: PropTypes.object
};

export default UsersPermissions;